import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppServiceHelperService } from '../../../services/app-service-helper.service';

/**
 * VAL Event role management service
 */
@Injectable({
  providedIn: 'root'
})
export class ValuationEvenRoleManagementService {
  /**
   * The properties resource URL
   */
  private _valuationEventsResource: string;

  /**
 * The properties resource URL
 */
  private _settingsResource: string;

  /**
   * Constructor
   * @param httpClient
   * @param appServiceHelper
   */
  constructor(private httpClient: HttpClient, private appServiceHelper: AppServiceHelperService) {
    this._valuationEventsResource = this.appServiceHelper.getServiceEndpoint('pollux.projectValuation.api', 'ValuationPortfolios');
    this._settingsResource = this.appServiceHelper.getServiceEndpoint('pollux.settings.api', 'user');
  }

  /**
   * Loads the users
   * @returns
   */
  getUsers() {
    return this.httpClient.get<any>(`${this._settingsResource}`);
  }

  /**
   * Loads the roles
   * @returns
   */  getRoles() {

    return this.httpClient.get<any>(`${this._valuationEventsResource}/roles`);
  }

  /**
   * Loads the role assignments
   * @param valuationPortfolioId
   * @returns
   */
  roleAssignments(valuationPortfolioId: number) {
    return this.httpClient.get<any>(`${this._valuationEventsResource}/roleAssignments?valuationPortfolioId=${valuationPortfolioId}`);
  }

  /**
   * Deletes a role assignment
   * @param oid
   * @returns
   */
  deleteRoleAssignment(oid: number) {
    return this.httpClient.post<any>(`${this._valuationEventsResource}/roleAssignments/delete`, { oid: oid });
  }
}
